import React from "react";
import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import { PagesProvider } from "./store/PagesContext";
import Configurator from "./pages/Configurator";
import GraphView from "./pages/GraphView";

export default function App() {
  return (
    <BrowserRouter>
      <PagesProvider>
        <nav className="bg-white border-b">
          <div className="px-4 h-12 flex items-center justify-between">
            
            {/* Left side: main nav */}
            <div className="flex items-center gap-2">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `px-2 py-1 rounded text-sm ${
                    isActive
                      ? "bg-gray-300 text-gray-900"
                      : "text-gray-700 hover:bg-gray-100"
                  }`
                }
              >
                Home
              </NavLink>

              <NavLink
                to="/graph"
                className={({ isActive }) =>
                  `px-2 py-1 rounded text-sm ${
                    isActive
                      ? "bg-gray-300 text-gray-900"
                      : "text-gray-700 hover:bg-gray-100"
                  }`
                }
              >
                Graph
              </NavLink>
            </div>

            {/* Right side: page-specific actions */}
            <div className="flex items-center gap-2">
              {/* You could use context or location to decide which buttons to render here */}
            </div>
          </div>
        </nav>


        <Routes>
          <Route path="/" element={<Configurator />} />
          <Route path="/graph" element={<GraphView />} />
        </Routes>
      </PagesProvider>
    </BrowserRouter>
  );
}
